import styled from '@emotion/styled';
import { Avatar as _Avatar, Typography } from '@material-ui/core';
import AccountCircle from '@material-ui/icons/AccountCircle';
import { createElement } from 'react';

import { subText } from '../../constant/color';
import { SPACING_UNIT } from '../../constant/spacing';

interface Props {
  imageUrl?: string;
  name: string;
  small?: boolean;
  className?: string;
}

const AvatarWithName = ({ imageUrl, name, small, className }: Props) => {
  let avatar;
  if (!imageUrl) {
    avatar = small ? <SmallIcon color="primary" /> : <Icon color="primary" />;
  } else {
    avatar = small ? <SmallAvatar alt={name} src={imageUrl} /> : <Avatar alt={name} src={imageUrl} />;
  }

  return (
    <Root className={className}>
      {avatar}
      <Name variant="body2">{name}</Name>
    </Root>
  );
};

export const Root = styled('div')({
  display: 'flex',
  alignItems: 'center',
});

const Avatar = styled(_Avatar)({
  width: 32,
  height: 32,
});

const SmallAvatar = styled(_Avatar)({
  width: 20,
  height: 20,
});

const Icon = styled(AccountCircle)({
  width: 32,
  height: 32,
  color: subText,
});

const SmallIcon = styled(AccountCircle)({
  width: 20,
  height: 20,
  color: subText,
});

const Name = styled(Typography)({
  marginLeft: SPACING_UNIT,
  maxWidth: 300,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  color: subText,
});

export default AvatarWithName;
